import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../src/components/Navbar/Navbar';
import CardInformations from './components/CardInformation/Card';
import MapArea from './components/MapComponent/Map';
import ListaSensores from './components/ListSensor/listaSensores';
import io from 'socket.io-client';
import api from './service/api';

import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';



import SensorImage from './images/sensor.png';
import SunImage from './images/wave.png';
import UmidadeIcon from './images/soil.png';
import WindIcon from './images/precipitation.png';
import SmokeIcon from './images/ground.png';
import AlertIcon from './images/check.png';
import AlertaIcon from './images/alerta.png';

import Fab from '@mui/material/Fab';



export default () => {

  const [modal, setModal] = useState(false);


  const handleActiveAlert = () =>{
    setModal(true);
  };

  useEffect(() =>{

    const newSocketClient = io('https://ssophia.econeteditora.com.br/', { transports: ['websocket'] });

    api.onNewMessage(newSocketClient, handleActiveAlert);

    return () => newSocketClient.close();

  },[]);




  return (
    <div className="App">
      <Navbar />
      <CardInformations 
        title="PROBE"
        body="10/20"
        image={SensorImage}
      />
      <CardInformations 
        title="INFRASOUND (PIEZO)"
        body="12.3 Hz"
        image={SunImage}
      />
      <CardInformations 
        title="SOIL MOISTURE"
        body="27%"
        image={UmidadeIcon}
      />
      <CardInformations 
        title="RAIN PRECIPITATION"
        body="45 MM"
        image={WindIcon}
      />
      <CardInformations 
        title="GROUND MOVEMENT"
        body="2 µs"
        image={SmokeIcon}
      />
      {/* <CardInformations 
        title="ALERT"
        body=""
        image={AlertIcon}
      /> */}
      <MapArea />
      <ListaSensores />

      <PureModal
        className="modalChatinha"
        header="WARNING"
        footer={
          <div className="button-modal">
            <Fab variant="extended" size="small" color='primary' aria-label="add" className="button-abrir" >
              OPEN CHAT
            </Fab>
            <Fab variant="extended" size="small" color='primary' aria-label="add" className="button-sair">
              PANIC
            </Fab>
            <Fab variant="extended" size="small" color='primary' aria-label="add" className="button-safe">
              SAFE !
            </Fab>
          </div>
        }
        isOpen={modal}
        onClose={() => {
          setModal(false);
          return true;
        }}
      >
        <div className="content-modal">
          <div className="div-texto-modal">
            <p>SENSOR: Bonfim #Épsilon</p>
            <p>MESSAGE: High probability of landslide</p>
            <p>INFRASOUND (PIEZO): 12.3 Hz</p>
            <p>SOIL MOISTURE: 27 %</p>
            <p>LOCATION: -14.067534, -47.561225</p>
            <p>EVACUATE THIS AREA IMMEDIATELY!</p>
            <br />
            <br />
            <p>Alerting Authorities....</p>
            <p>Alerting Community brigade......</p>
          </div>
          <div className="div-image-modal">
            <img src={AlertaIcon} className="image-alert"/>
          </div>
        </div>
      </PureModal>
    </div>
  );
}
